import { api } from "@/lib/http";

// Legacy anonymous browser id (kept for any local prefs; no longer sent to API)
export function getClientId() {
  let id = localStorage.getItem("laser_calc_client_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || `c_${Date.now()}_${Math.random().toString(36).slice(2)}`;
    localStorage.setItem("laser_calc_client_id", id);
  }
  return id;
}

export async function fetchDevices() {
  const { data } = await api.get("/devices");
  return data;
}

export async function saveDevice({ name, brand, params }) {
  const { data } = await api.post("/devices", { name, brand, params });
  return data;
}

export async function updateDevice(id, payload) {
  const { data } = await api.put(`/devices/${id}`, payload);
  return data;
}

export async function deleteDevice(id) {
  const { data } = await api.delete(`/devices/${id}`);
  return data;
}

export async function fetchTreatments() {
  const { data } = await api.get("/treatments");
  return data;
}

export async function saveTreatment(payload) {
  const { data } = await api.post("/treatments", payload);
  return data;
}

export async function deleteTreatment(id) {
  const { data } = await api.delete(`/treatments/${id}`);
  return data;
}
